import { apiGet } from 'shared/services/api/resource';
import { CURRENT_PLAN, UPCOMING_SESSIONS, UPGRADE_OPTIONS } from 'modules/jogador/classes/content';
import { ClassPlan, ClassSession, UpgradeOption } from 'modules/jogador/classes/types';

export interface MyClassesData {
  plan: ClassPlan;
  upcomingSessions: ClassSession[];
  upgradeOptions: UpgradeOption[];
}

export function fetchMyClasses(): Promise<MyClassesData> {
  return apiGet({ plan: CURRENT_PLAN, upcomingSessions: UPCOMING_SESSIONS, upgradeOptions: UPGRADE_OPTIONS }, '/me/classes');
}
